import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'
import numeral from 'numeral'

// import IrreversibleCheckbox from '../IrreversibleCheckbox/IrreversibleCheckbox'
import IrreversibleModalConfirmCheckbox from '../IrreversibleModalConfirmCheckbox/IrreversibleModalConfirmCheckbox'
import './PaymentInvoiceTable.scss'

export default class PaymentInvoiceTable extends Component {
    getBudget(percentage) {
        const { grandTotal } = this.props
        return grandTotal * (percentage / 100)
    }

    render() {
        const { isAuthorized, status, onPaymentStatusChange, isDocumentSent, payments } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || !isDocumentSent || !isAuthorized
        const tableColumns = [{
            title: 'Payment Name',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: 200
        }, {
            title: 'Percentage',
            dataIndex: 'percentage',
            key: 'amount',
            render: percentage => `${percentage} %`
        }, {
            title: 'Budget',
            dataIndex: 'amount',
            key: 'budget',
            render: amount => numeral(amount).format('$ 0,0.[0]')
        }, {
            title: 'Invoice Sent',
            dataIndex: 'invoice_sent',
            key: 'invoice_sent',
            render: (invoice_sent, record, index) => <IrreversibleModalConfirmCheckbox fieldName="invoice_sent" checked={invoice_sent} onChange={() => onPaymentStatusChange(index, 'invoice_sent', invoice_sent)} disabled={isLocked || !record.invoice_exported}/>
        }, {
            title: 'Paid',
            dataIndex: 'paid',
            key: 'paid',
            render: (paid, record, index) => {
                const invoicePaidAt = (record.invoice_id && record.invoice_id.paid_at && moment(record.invoice_id.paid_at).format('YYYY-MM-DD')) || (record.paidAt ? record.paidAt.format('YYYY-MM-DD') : '--')
                return <div>
                    <IrreversibleModalConfirmCheckbox fieldName="paid" checked={paid} onChange={(paidDate) => onPaymentStatusChange(index, 'paid', paid, paidDate)} disabled={isLocked || !record.invoice_sent}/>
                    <span>Paid at: {invoicePaidAt}</span>
                </div>
            }
        }, {
            title: 'Receipt Sent',
            dataIndex: 'receipt_sent',
            key: 'receipt_sent',
            render: (receipt_sent, record, index) => <IrreversibleModalConfirmCheckbox fieldName="receipt_sent" checked={receipt_sent} onChange={() => onPaymentStatusChange(index, 'receipt_sent',receipt_sent)} disabled={isLocked || !record.paid || !record.receipt_exported}/>
        }, {
            title: 'Void',
            dataIndex: 'void',
            render: (text, record, index) => <IrreversibleModalConfirmCheckbox fieldName="void" disabled />
        }]

        return (
            <Table
                className="PaymentInvoiceTable"
                dataSource={payments}
                rowKey={(record, idx) => `${record.name}-${idx}`}
                columns={tableColumns}
                pagination={false}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/PaymentInvoiceTable/PaymentInvoiceTable.js